import React from 'react';
import { ShieldCheckIcon, StarIcon } from 'lucide-react';
import { CHECKOUT_URL, CtaButton } from './CtaButton';
export function FinalCtaSection() {
  return <section className="w-full bg-forest-800 px-6 py-14 sm:py-20" aria-labelledby="cierre-titulo" data-id="element-61" data-mp="3lwj52d4qat6k">
      <div className="mx-auto max-w-3xl text-center" data-id="element-62" data-mp="3qrosjgds4fwr">
        <h2 id="cierre-titulo" className="font-display text-3xl font-bold leading-tight text-cream-50 sm:text-5xl" data-id="element-63" data-mp="3vrky3k24kfef">
          Tu acceso completo te espera
        </h2>

        <blockquote className="mt-6 font-display text-xl italic leading-relaxed text-cream-100/80 sm:text-2xl" data-id="element-64" data-mp="33504se239t88">
          “La próxima clase que des sobre integración, podés abrir el Volumen 1, seguir el Bono 1 como guía,
          usar el Checklist (Bono 2) para que tus alumnos diagnostiquen correctamente, y cerrar con un
          proyecto del Bono 6. Todo conectado. Todo profesional. Todo resuelto.”
        </blockquote>

        <div className="mt-8 rounded-3xl border border-cream-100/15 bg-white/[0.06] p-7 sm:p-9" data-id="element-65" data-mp="2kbmjl0o6h15t">
          <p className="text-base text-cream-100/75" data-id="element-66" data-mp="2db8g5gqfzba4">
            Mega Kit Integración Campo-PLC-SCADA 2026 — 6 Volúmenes + 6 Bonos + 548 Páginas
          </p>
          <p className="mt-5 flex items-baseline justify-center gap-4" data-id="element-67" data-mp="23lf6wmdrv891">
            <span className="font-display text-2xl text-cream-100/70 line-through" data-id="element-68" data-mp="1yn3vi77twpop">$76 USD</span>
            <span className="font-display text-5xl font-bold text-cream-50 sm:text-6xl" data-id="element-69" data-mp="1uliov3lw17my">$19 USD</span>
          </p>
          <p className="mt-2 text-xs text-[#EBA96F]" data-id="element-70" data-mp="1plwaury8jnd3">Se abona en tu moneda local</p>
          <p className="mx-auto mt-5 max-w-md text-base text-cream-100/85" data-id="element-71" data-mp="1kncpasnk0dl9">
            Pago único. Acceso en 5 minutos. Incluye los 6 volúmenes técnicos + los 6 bonos sin costo
            adicional.
          </p>
          <CtaButton className="mt-8" href={CHECKOUT_URL} source="cierre" data-id="element-72" data-mp="3f1vqmrwd0b1p" />
          <div className="mt-6 flex flex-col items-center justify-center gap-3 text-sm text-cream-100/85 sm:flex-row sm:gap-5" data-id="element-73" data-mp="3eyzosshe527z">
            <span className="flex items-center gap-2" data-id="element-74" data-mp="18clfccgxsgbr">
              <span className="flex" aria-hidden="true" data-id="element-75" data-mp="18b0hodzbsh9o">
                {[0, 1, 2, 3, 4].map(i => <StarIcon key={i} className="h-4 w-4 fill-ember-400 text-ember-400" data-id="element-76" data-mp="1d5mvensvqlwx" />)}
              </span>
              4.9/5 — Calificación de docentes
            </span>
            <span className="hidden h-4 w-px bg-cream-100/20 sm:block" aria-hidden="true" data-id="element-77" data-mp="13bxnxpospxh0" />
            <span className="flex items-center gap-2" data-id="element-78" data-mp="1r4e8c6w0a1jh">
              <ShieldCheckIcon className="h-4 w-4" aria-hidden="true" data-id="element-79" data-mp="1w2xuo8eihfcd" />
              Garantía 7 días
            </span>
          </div>
        </div>
      </div>
    </section>;
}